import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3531bc31")

_pushScopeId("data-v-3531bc31")
const _hoisted_1 = { class: "bannerText" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("手游全链路自动化测试专家")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("GameRobot游戏机器人")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("支持游戏行为的精准录制和回放，一次录制，随时回放。手机无需ROOT/越狱，极简使用体验。")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 项目接入 ")
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "el-icon-s-promotion" }, null, -1)
const _hoisted_7 = { href: "/project_overview" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 开始使用 ")
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "el-icon-right" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Copyright ©  ")
const _hoisted_11 = { style: {"color":"mediumseagreen","margin-bottom":"0"} }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  品质管理部成都二组. 自动化平台 企业微信联系：pagezhang ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_footer = _resolveComponent("el-footer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_row, {
        style: {"height":"calc(100vh - 122px)"},
        type: "flex",
        justify: "center",
        align: "middle",
        class: "first"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_col, {
            style: {"z-index":"2","margin-top":"-10%"},
            class: "firstTitle"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "center",
                align: "middle",
                class: "intro"
              }, {
                default: _withId(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "center",
                align: "middle",
                class: "intro"
              }, {
                default: _withId(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_el_row),
              _createVNode(_component_el_row, {
                type: "flex",
                justify: "space-between",
                align: "middle",
                class: "details"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_col, { span: 6 }),
                  _createVNode(_component_el_col, {
                    span: 7,
                    style: {"text-align":"center","font-size":"1.3rem"}
                  }, {
                    default: _withId(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 2 }, {
                    default: _withId(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        style: {"width":"150px","height":"60px","font-size":"1.3rem","font-weight":"bold"},
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.project_access()))
                      }, {
                        default: _withId(() => [
                          _hoisted_5,
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, {
                    span: 7,
                    style: {"text-align":"left"}
                  }, {
                    default: _withId(() => [
                      _createVNode("a", _hoisted_7, [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          style: {"width":"150px","height":"60px","font-size":"1.3rem","font-weight":"bold"}
                        }, {
                          default: _withId(() => [
                            _hoisted_8,
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { style: {"z-index":"1","position":"absolute","top":"0","right":"0","height":"100%","width":"100%","opacity":"0.5"} }, {
            default: _withId(() => [
              _createVNode(_component_el_image, {
                src: _ctx.bgUrl,
                style: {"width":"100%","height":"100%"},
                fit: "cover"
              }, null, 8, ["src"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_footer, { class: "footer" }, {
      default: _withId(() => [
        _hoisted_10,
        _createVNode("p", _hoisted_11, _toDisplayString(_ctx.year), 1),
        _hoisted_12
      ]),
      _: 1
    })
  ], 64))
})